// iter679 — Twin Mood helper.
// Maps a raw 0-100 sub-score (or null when twin has no data yet) into a
// "mood" label that the dashboard can use to humanise the twin grid.
//
// Bands deliberately leave room for nuance (4 levels instead of 3) so that
// users can see the difference between "fine" (80+) and "good but watch"
// (65-79). Colours match the existing palette used in the tile score numbers.

export const MOODS = {
  calm:    { id: "calm",    emoji: "🙂", label_bg: "спокоен",         color: "#10b981", pulse: false },
  steady:  { id: "steady",  emoji: "🧘", label_bg: "стабилен",        color: "#3b82f6", pulse: false },
  tense:   { id: "tense",   emoji: "😟", label_bg: "напрегнат",       color: "#f59e0b", pulse: true  },
  alert:   { id: "alert",   emoji: "🔥", label_bg: "нуждае внимание", color: "#f43f5e", pulse: true  },
  unknown: { id: "unknown", emoji: "•",  label_bg: "няма данни",      color: "#94a3b8", pulse: false },
};

export function getMood(score) {
  if (score === null || score === undefined || Number.isNaN(score)) return MOODS.unknown;
  if (score >= 80) return MOODS.calm;
  if (score >= 65) return MOODS.steady;
  if (score >= 50) return MOODS.tense;
  return MOODS.alert;
}

// Aggregate the whole twin grid mood for a one-line summary
export function summariseMoods(subScores) {
  const counts = { calm: 0, steady: 0, tense: 0, alert: 0, unknown: 0 };
  Object.values(subScores || {}).forEach((v) => {
    counts[getMood(v).id] += 1;
  });
  return counts;
}
